/**
 * URL path segments for learner item routes.
 * These are used in routes like `/learn/:courseSlug/:itemRoutePath/:item_id`
 */
export const ITEM_ROUTE_PATHS = {
  LECTURE: 'lecture',
  QUIZ: 'quiz',
  EXAM: 'exam',
  PEER: 'peer',
  PROGRAMMING: 'programming',
  SUPPLEMENT: 'supplement',
  DISCUSSION_PROMPT: 'discussionPrompt',
  GRADED_DISCUSSION_PROMPT: 'gradedDiscussionPrompt',
  UNGRADED_WIDGET: 'ungradedWidget',
  GRADED_WIDGET: 'gradedWidget',
  WISE_FLOW: 'wiseFlow',
  GRADED_LTI: 'gradedLti',
  UNGRADED_LTI: 'ungradedLti',
  UNGRADED_LAB: 'ungradedLab',
  COACH: 'coach',
  TEAMMATE_REVIEW: 'teammate-review',
  ASSIGNMENT_SUBMISSION: 'assignment-submission',
  ACTIVITY: 'activity',
  PLACEHOLDER: 'placeholder',
} as const;
